//---------------angular staff---------------
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { GoogleMapsModule } from '@angular/google-maps';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PdfViewerModule } from "ng2-pdf-viewer";
import { VgStreamingModule } from "@videogular/ngx-videogular/streaming";
import { VgCoreModule } from "@videogular/ngx-videogular/core";
import { NgxEditorModule } from "ngx-editor";
import { DatePipe } from '@angular/common';
import { PickerModule } from "@ctrl/ngx-emoji-mart";

//---------------components------------------
import { FinalizeComponent } from '../shared/components/finalize/finalize.component';
import { CarouselComponentModule, Home365LoaderModule, SupportChatModule } from '@home365/ui/components';

//---------------nodules---------------------
import { SharedModule } from '../shared/shared.module';
import { ChatComponent } from './chat/chat.component';
import { ImgViewerComponent } from './chat/img-viewer/img-viewer.component';
import { BoardFilterComponent } from './chat/boardFilter/boardFilter.component';
import { MaterialModule } from '../material.module';
import { LoaderModule } from '../shared/components/loader/loader.module';
import { ChatInputComponent } from './chat/chatInput/chatInput.component';
import { ChatInputFormComponent } from './chat/chatInput/chat-input-form/chat-input-form.component';
import { MultipleFilesUploadComponent } from './chat/chatInput/multiple-files-upload/multiple-files-upload.component';
import { BrowserModule } from '@angular/platform-browser';
import { AddLinkComponentComponent } from './chat/chatInput/add-link-component/add-link-component.component';
import { ServiceReviewComponent } from './chat/service-review/service-review.component';
import { CallTranscriptComponent } from './chat/CallTranscript/CallTranscript.component';


@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    MaterialModule,
    SupportChatModule,
    LoaderModule,
    PdfViewerModule,
    VgStreamingModule,
    VgCoreModule,
    Home365LoaderModule,
    NgxEditorModule,
    ReactiveFormsModule,
    FormsModule,
    CarouselComponentModule,
    PickerModule
  ],
  declarations: [
    ChatComponent,
    ImgViewerComponent,
    BoardFilterComponent,
    ChatInputComponent,
    ChatInputFormComponent,
    MultipleFilesUploadComponent,
    AddLinkComponentComponent,
    ServiceReviewComponent,
    CallTranscriptComponent
  ],
  exports: [
    ChatComponent,
    ImgViewerComponent,
    ServiceReviewComponent
  ],
  entryComponents: [
    ImgViewerComponent,
    AddLinkComponentComponent,
    CallTranscriptComponent
  ],
  providers:[
    DatePipe
  ]
})
export class SupprotChatBoxModule { }
